"use strict";
/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelSortDirection = exports.WebhookEvent = exports.PaymentStatus = exports.NotificationStatus = exports.NotificationChannel = exports.TransactionStatus = exports.StorageTransactionType = exports.StorageTransactionStatus = exports.NodeType = exports.StorageClass = exports.BundleStatus = exports.NodeStatus = exports.MembershipStatus = exports.MembershipRole = exports.OrganisationRole = exports.ModelAttributeTypes = exports.VaultStatus = void 0;
var VaultStatus;
(function (VaultStatus) {
    VaultStatus["ACTIVE"] = "ACTIVE";
    VaultStatus["ARCHIVED"] = "ARCHIVED";
    VaultStatus["DELETED"] = "DELETED";
})(VaultStatus || (exports.VaultStatus = VaultStatus = {}));
var ModelAttributeTypes;
(function (ModelAttributeTypes) {
    ModelAttributeTypes["binary"] = "binary";
    ModelAttributeTypes["binarySet"] = "binarySet";
    ModelAttributeTypes["bool"] = "bool";
    ModelAttributeTypes["list"] = "list";
    ModelAttributeTypes["map"] = "map";
    ModelAttributeTypes["number"] = "number";
    ModelAttributeTypes["numberSet"] = "numberSet";
    ModelAttributeTypes["string"] = "string";
    ModelAttributeTypes["stringSet"] = "stringSet";
    ModelAttributeTypes["_null"] = "_null";
})(ModelAttributeTypes || (exports.ModelAttributeTypes = ModelAttributeTypes = {}));
var OrganisationRole;
(function (OrganisationRole) {
    OrganisationRole["ADMIN"] = "ADMIN";
    OrganisationRole["MEMBER"] = "MEMBER";
})(OrganisationRole || (exports.OrganisationRole = OrganisationRole = {}));
var MembershipRole;
(function (MembershipRole) {
    MembershipRole["OWNER"] = "OWNER";
    MembershipRole["CONTRIBUTOR"] = "CONTRIBUTOR";
    MembershipRole["VIEWER"] = "VIEWER";
})(MembershipRole || (exports.MembershipRole = MembershipRole = {}));
var MembershipStatus;
(function (MembershipStatus) {
    MembershipStatus["ACCEPTED"] = "ACCEPTED";
    MembershipStatus["PENDING"] = "PENDING";
    MembershipStatus["INVITED"] = "INVITED";
    MembershipStatus["REJECTED"] = "REJECTED";
    MembershipStatus["REVOKED"] = "REVOKED";
})(MembershipStatus || (exports.MembershipStatus = MembershipStatus = {}));
var NodeStatus;
(function (NodeStatus) {
    NodeStatus["ACTIVE"] = "ACTIVE";
    NodeStatus["REVOKED"] = "REVOKED";
    NodeStatus["DELETED"] = "DELETED";
})(NodeStatus || (exports.NodeStatus = NodeStatus = {}));
var BundleStatus;
(function (BundleStatus) {
    BundleStatus["COMMITTED"] = "COMMITTED";
    BundleStatus["UPLOADING"] = "UPLOADING";
    BundleStatus["PENDING"] = "PENDING";
    BundleStatus["REJECTED"] = "REJECTED";
    BundleStatus["SCHEDULED"] = "SCHEDULED";
})(BundleStatus || (exports.BundleStatus = BundleStatus = {}));
var StorageClass;
(function (StorageClass) {
    StorageClass["ARWEAVE"] = "ARWEAVE";
    StorageClass["CLOUD"] = "CLOUD";
})(StorageClass || (exports.StorageClass = StorageClass = {}));
var NodeType;
(function (NodeType) {
    NodeType["STACK"] = "STACK";
    NodeType["NFT"] = "NFT";
})(NodeType || (exports.NodeType = NodeType = {}));
var StorageTransactionStatus;
(function (StorageTransactionStatus) {
    StorageTransactionStatus["BANNED"] = "BANNED";
    StorageTransactionStatus["BLOCKED"] = "BLOCKED";
    StorageTransactionStatus["BUNDLED"] = "BUNDLED";
    StorageTransactionStatus["CANCELLED"] = "CANCELLED";
    StorageTransactionStatus["COMMITTED"] = "COMMITTED";
    StorageTransactionStatus["PENDING"] = "PENDING";
    StorageTransactionStatus["REGISTERED"] = "REGISTERED";
    StorageTransactionStatus["REJECTED"] = "REJECTED";
    StorageTransactionStatus["SCHEDULED"] = "SCHEDULED";
    StorageTransactionStatus["VERIFICATION"] = "VERIFICATION";
})(StorageTransactionStatus || (exports.StorageTransactionStatus = StorageTransactionStatus = {}));
var StorageTransactionType;
(function (StorageTransactionType) {
    StorageTransactionType["AUDIO"] = "AUDIO";
    StorageTransactionType["DOCUMENTS"] = "DOCUMENTS";
    StorageTransactionType["METADATA"] = "METADATA";
    StorageTransactionType["NOTES"] = "NOTES";
    StorageTransactionType["OTHER"] = "OTHER";
    StorageTransactionType["PHOTOS"] = "PHOTOS";
    StorageTransactionType["STATE"] = "STATE";
    StorageTransactionType["TOPUP"] = "TOPUP";
    StorageTransactionType["VIDEO"] = "VIDEO";
})(StorageTransactionType || (exports.StorageTransactionType = StorageTransactionType = {}));
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["PENDING"] = "PENDING";
    TransactionStatus["COMMITTED"] = "COMMITTED";
})(TransactionStatus || (exports.TransactionStatus = TransactionStatus = {}));
var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["EMAIL"] = "EMAIL";
    NotificationChannel["INAPP"] = "INAPP";
})(NotificationChannel || (exports.NotificationChannel = NotificationChannel = {}));
var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["READ"] = "READ";
    NotificationStatus["UNREAD"] = "UNREAD";
})(NotificationStatus || (exports.NotificationStatus = NotificationStatus = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["FAILED"] = "FAILED";
    PaymentStatus["INVOICED"] = "INVOICED";
    PaymentStatus["OPEN"] = "OPEN";
    PaymentStatus["PAID"] = "PAID";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
var WebhookEvent;
(function (WebhookEvent) {
    WebhookEvent["TRANSACTION_CREATED"] = "TRANSACTION_CREATED";
    WebhookEvent["TRANSACTION_COMMITTED"] = "TRANSACTION_COMMITTED";
})(WebhookEvent || (exports.WebhookEvent = WebhookEvent = {}));
var ModelSortDirection;
(function (ModelSortDirection) {
    ModelSortDirection["ASC"] = "ASC";
    ModelSortDirection["DESC"] = "DESC";
})(ModelSortDirection || (exports.ModelSortDirection = ModelSortDirection = {}));
